import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "/app/src/app/components/HeroSection/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/src/shared/components/Button/Button.tsx");
